import { render } from "./YoutubeSearch.vue?vue&type=template&id=6af484ef"
import script from "./YoutubeSearch.vue?vue&type=script&lang=js"
export * from "./YoutubeSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__